import { Emisor } from "../Emisor/Emisor";
import { EstadoValidacionDteRecibido } from "../Proveedor/EstadoValidacionDteRecibido.enum";
import { DterecibidoFile } from "./DteRecibidoFile";

export class DteRecibido {
	dteId: string;
	proveedorId: string;
	emisorId: string;
	tipoDteId: string;
	codigoTipoDte: number;
	folio: number;
	estadoSii: number;
	neto: number;
	iva: number;
	exento: number;
	total: number;
	impuestos: number;
	dteRecibidoFile: DterecibidoFile;
	emisorAsociado: Emisor;
	nombreTipoDte: string;
	rutProveedorDv: string;
	razonSocialProveedor: string;
	comunaProvedor: string;
	ciudadProveedor: string;
	giroProveedor: string;
	dirFactProveedor: string;
	correoParProveedor: string;
	estadoNombre: string;
	estado: number;
	diasPendientes: string;
	motivo: string;
	acuseReciboId: string;
	acuseHabilitado: boolean;
	respuestaAcuseRecibo: string;
	respuestaEstadoId: string;
	estadoFinal: string;

	fechaUltimoProcesamiento: Date;
	fechaRecepcionSii: Date;
	fechaEmision: Date;
	fechaVencimiento: Date;
	fechaVencimientoAcuse: Date;
	fechaAcuse: Date;
	resultadoValidacionAutomatica: string;
	estadoValidacionId: EstadoValidacionDteRecibido;
	fechaPago: Date;
	conArchivo: boolean;

	nula: boolean;
	tieneNC: boolean;
    cedida: boolean;

    showActions?: boolean;
    tieneTipoAcuse: boolean;
    referencias: string;
	/** Codigo de referencia procesado para mostrar en grilla (p.e. 801 => OC) */
	referenciaCodigo?: string;
	/** Texto de tooltip descriptivo de la referencia (p.e. Orden Compra) */
	referenciaTooltip?: string;
	pdfUrl: string;
}
